import * as React from 'react'
import { graphql } from 'gatsby'
import { Trans } from 'gatsby-plugin-react-i18next'
import HomeHero from '../components/HomeHero'
import SectionTechnology from '../components/SectionTechnology'
import TilesSwiper from '../components/TilesSwiper'
import HomeContact from '../components/HomeContact'
import HomeProducts from '../components/HomeProducts'
import { Seo } from '../components/SEO'

import Icon1 from '../assets/svg/Icon1.inline.svg'
import Icon2 from '../assets/svg/Icon2.inline.svg'
import Icon3 from '../assets/svg/Icon3.inline.svg'
import Icon4 from '../assets/svg/Icon4.inline.svg'
import Icon5 from '../assets/svg/Icon5.inline.svg'
import Icon6 from '../assets/svg/Icon6.inline.svg'

const SlideTiles = [
  {
    heading: <Trans>SlideTilesHeading_1</Trans>,
    content: <Trans>SlideTilesContent_1</Trans>,
    icon: <Icon1 />,
  },
  {
    heading: <Trans>SlideTilesHeading_2</Trans>,
    content: <Trans>SlideTilesContent_2</Trans>,
    icon: <Icon2 />,
  },
  {
    heading: <Trans>SlideTilesHeading_3</Trans>,
    content: <Trans>SlideTilesContent_3</Trans>,
    icon: <Icon3 />,
  },
  {
    heading: <Trans>SlideTilesHeading_4</Trans>,
    content: <Trans>SlideTilesContent_4</Trans>,
    icon: <Icon4 />,
  },
  {
    heading: <Trans>SlideTilesHeading_5</Trans>,
    content: <Trans>SlideTilesContent_5</Trans>,
    icon: <Icon5 />,
  },
  {
    heading: <Trans>SlideTilesHeading_6</Trans>,
    content: <Trans>SlideTilesContent_6</Trans>,
    icon: <Icon6 />,
  },
]

export default function Home() {
  return (
    <>
      {/* For give to scroll give element id without # */}
      <HomeHero whereToScroll='products' />
      {/* DONT GIVE ANY ID FOR HomeProducts, by default it is #products */}
      <HomeProducts />
      <SectionTechnology
        id='sectionTechnology'
        heading={<Trans>SectionTechnologyHeading</Trans>}
        content={<Trans>SectionTechnologyContent</Trans>}
      />
      {/* GridStyles prop has as default "hidden md:grid" */}
      {/* SlideTiles means array like on top in this file */}
      <TilesSwiper
        SlideTiles={SlideTiles}
        GridStyles='lg:grid-cols-3 grid-cols-2 auto-rows-fr gap-[16px]'
        heading={<Trans>TilesSwiperHeading</Trans>}
        content={<Trans>TilesSwiperContent</Trans>}
      />
      <HomeContact
        heading={<Trans>HomeContactHeading</Trans>}
        content={<Trans>HomeContactContent</Trans>}
      />
    </>
  )
}

export const Head = () => (
  <Seo
    title='Visual inspection car/vehicle | Vumo.ai'
    description='Get The Whole Image™ Robot-powered imaging and inspection for the automotive industry.'
  />
)

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { language: { eq: $language }, ns: { eq: "index" } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
